import { getPreviewPackageDocumentUrl } from '@/services/dashboard/previewPackageDocument'
import { LoadingPreview } from '@/components/preview/PreviewLoader'
import { useEffect } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'

type PreviewPackageSearch = {
  workOrderId: number
  workOrderShippingId: number
  isReadOnly?: boolean
}

export const Route = createFileRoute('/previewPackage')({
  validateSearch: (search): PreviewPackageSearch => ({
    workOrderId:
      typeof search.workOrderId === 'number' ? search.workOrderId : -1,
    workOrderShippingId:
      typeof search.workOrderShippingId === 'number'
        ? search.workOrderShippingId
        : -1,
    isReadOnly:
      typeof search.isReadOnly === 'boolean' ? search.isReadOnly : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (!search.workOrderId || !search.workOrderShippingId) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: PreviewPackageRoute,
})

function PreviewPackageRoute() {
  const {
    workOrderId,
    workOrderShippingId,
    isReadOnly = false,
  } = Route.useSearch()
  useEffect(() => {
    window.location.replace(
      getPreviewPackageDocumentUrl(
        workOrderId,
        workOrderShippingId,
        isReadOnly,
      ),
    )
  }, [workOrderId, workOrderShippingId, isReadOnly])

  return <LoadingPreview />
}
